<ion-header class="ion-no-border">
  <ion-toolbar class="transparent_toolbar">
    <ion-buttons slot="start">
      <ion-button (click)="modalDismiss()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="form__content highlight-gradient">
  <form [formGroup]="form" *ngIf="form" class="form">
    <ion-grid [fixed]="true">
      <ion-row>
        <ion-col size="12">
          <h3 class="form__title">Вход</h3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <div class="input-form-group">
            <label class="input-label">Телефон</label>
            <div class="input_phone__wrapper">
              <input id="tel" class="input input_phone" formControlName="phone" type="tel" maxlength="18" phoneMask  [phoneControl]="form.controls['phone']" placeholder="+7 (___) ___-__-__">
            </div>
            <span class="input-error" *ngIf="form.get('phone')?.touched && form.get('phone')?.invalid" slot="error">Введите номер</span>
          </div>

          <div class="input-form-group">
            <ion-label class="input-label">Пароль</ion-label>
            <app-show-hide-password>
              <ion-input class="input input_password" formControlName="password" type="password"></ion-input>
            </app-show-hide-password>
            <ion-note class="input-error" *ngIf="form.get('password')?.touched && form.get('password')?.invalid" slot="error">Введите пароль</ion-note>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <div class="form__buttons">
            <ion-button shape="round" color="danger" class="button button_round" (click)="send()" [disabled]="isSend">Войти с паролем</ion-button>
            <ion-label class="separate mb-1 mt-1">или</ion-label>
            <ion-button shape="round" class="button button_round button_light" (click)="sendSmsCode()" [disabled]="isSend">Отправить код</ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>

</ion-content>

